import React from 'react';
import '../styles/PhotoBannerGallery.css';

interface Props {
  images: Record<string, string>[]
}

const PhotoBannerGallery: React.FC<Props> = ({images}) => {


  return (
    <div className="container-fluid px-0 banner-gallery">
      <div className="row g-1">
        {/* Colonne gauche - grande image */}
        <div className="col-md-6">
          <div className="h-100 w-100 rounded overflow-hidden banner-img-container">
            <img
              src={images[0].url}
              alt="Grande image"
              className="img-fluid w-100 h-100 banner-img"
            />
          </div>
        </div>

        {/* Colonne droite - 4 images en grille 2x2 */}
        <div className="col-md-6">
          <div className="row g-1">
            {images.slice(1).map((image: Record<string, string>, idx: number) => (
              <div className="col-6" key={idx}>
                <div className="rounded overflow-hidden banner-img-container">
                  <img
                    src={image.url}
                    alt={`Image ${idx + 2}`}
                    className="img-fluid w-100 h-100 banner-img"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoBannerGallery;
